export default __webpack_public_path__ + "static/media/right_icon.d07b63b9.svg";